import { render } from "./message-input-at.vue?vue&type=template&id=78536072&scoped=true&ts=true"
import script from "./message-input-at.vue?vue&type=script&lang=ts"
export * from "./message-input-at.vue?vue&type=script&lang=ts"

import "./message-input-at.vue?vue&type=style&index=0&id=78536072&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78536072"]])

export default __exports__